// Feedback / satisfaction API.
// ---------------------------------------------------------------------------
// Talks to the EIX-COPILOT backend (VITE_SETTINGS_URL, else VITE_AGENT_URL),
// which persists to Postgres (`feedback` table). Blank → a localStorage mock so
// the flow, moderation, and preview work in demos.
//
// Nothing is ever shown publicly on its own — a super admin approves/features
// items and chooses whether/where to publish (see appConfig feedback config).

const BASE = (import.meta.env.VITE_SETTINGS_URL || import.meta.env.VITE_AGENT_URL || '').replace(/\/$/, '');
const enabled = () => Boolean(BASE);
const token = () => localStorage.getItem('sendero_token') || '';
const authHeaders = () => ({ 'Content-Type': 'application/json', ...(token() ? { Authorization: `Bearer ${token()}` } : {}) });

const LS_KEY = 'sendero_feedback';
const readMock = () => { try { return JSON.parse(localStorage.getItem(LS_KEY) || '[]'); } catch { return []; } };
const writeMock = (list) => { try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch { /* ignore */ } };

export const feedbackApi = {
  /** Submit feedback (any signed-in user). */
  submit: async (payload) => {
    if (enabled()) {
     // const res = await fetch(`${BASE}/feedback`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(payload) });
        const res = await fetch(`${BASE}/api/provider/saveFeedback`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(payload) });
        const resData = await res.json();
     //   return { data: { Success: res.ok, Data: (await res.json())?.data } };
      return { data: { Success: res.ok, Data: resData.Data } };
    }
    const list = readMock();
    const record = { id: `FB-${Date.now()}`, status: 'new', createdAt: new Date().toISOString(), ...payload };
    list.unshift(record); writeMock(list);
    return { data: { Success: true, Data: record } };
  },

  /** List all feedback for moderation (super admin). */
  list: async () => {
    if (enabled()) {
    // const res = await fetch(`${BASE}/feedback`, { headers: authHeaders() });
        const res = await fetch(`${BASE}/api/provider/admin/getFeedbacks`, { headers: authHeaders() });
        const resData = await res.json();
      return { data: { Success: res.ok, Data: res.ok ? resData.Data || [] : [] } };
    //  return { data: { Success: res.ok, Data: res.ok ? (await res.json())?.data || [] : [] } };
    }
    return { data: { Success: true, Data: readMock() } };
    },

    /** List feedback for moderation (super admin) with server-side pagination, sorting, searching, and status filtering. */
    list2: async ({
        searchText = "",
        status = "",
        sortColumnName = "",
        sortColumnDirection = "",
        startIndex = 0,
        pageSize = 10,
    } = {}) => {
        if (enabled()) {
            const params = new URLSearchParams({
                searchText,
                status,
                sortColumnName,
                sortColumnDirection,
                startIndex: String(startIndex),
                pageSize: String(pageSize),
            });

            const res = await fetch(
                `${BASE}/api/provider/admin/getFeedbacks2?${params.toString()}`,
                { headers: authHeaders() }
            );

            const resData = await res.json();

          //  alert("resData : " +JSON.stringify(resData?.Data ));

            return {
                
                    success: res.ok,
                    data: res.ok ? resData?.Data || [] : [],
                    totalRecord: res.ok
                        ? resData.TotalRecord 
                        : 0,
                
            };
        }

        const mockData = readMock();

        return {
            data: {
                Success: true,
                Data: mockData,
                TotalRecord: mockData.length,
            },
        };
    },

  /** Set a feedback item's moderation status (super admin). */
  setStatus: async (id, status) => {
    if (enabled()) {
      //const res = await fetch(`${BASE}/feedback/${id}`, { method: 'PATCH', headers: authHeaders(), body: JSON.stringify({ status }) });
        const res = await fetch(`${BASE}/api/provider/admin/updateFeedbackStatus/${id}`, { method: 'PATCH', headers: authHeaders(), body: JSON.stringify({ status }) });
      return { data: { Success: res.ok } };
    }
    writeMock(readMock().map((f) => (f.id === id ? { ...f, status } : f)));
    return { data: { Success: true } };
  },

  /** Public social-proof payload: aggregate + approved/featured testimonials. */
  publicSummary: async () => {
    if (enabled()) {
     // try { const res = await fetch(`${BASE}/feedback/public`, { cache: 'no-store' }); if (res.ok) return { data: { Success: true, Data: await res.json() } }; } catch { /* fall through to mock */ }
        try {
            const res = await fetch(`${BASE}/api/provider/public/getFeedbacks`, { cache: 'no-store' });
            const resData = await res.json();
            if (res.ok) return { data: { Success: true, Data: resData.Data } };
            //if (res.ok) return { data: { Success: true, Data: await res.json() } };
        } catch { /* fall through to mock */ }
    }
    const all = readMock();
    const rated = all.filter((f) => Number(f.rating) > 0);
    const avg = rated.length ? rated.reduce((s, f) => s + Number(f.rating), 0) / rated.length : 0;
    const testimonials = all
      .filter((f) => (f.status === 'approved' || f.status === 'featured') && f.testimonial && f.consent)
      .sort((a, b) => (b.status === 'featured') - (a.status === 'featured'));
    return { data: { Success: true, Data: { average: Math.round(avg * 10) / 10, count: rated.length, testimonials } } };
  },
};

export default feedbackApi;
